import { render, staticRenderFns } from "./SuperScorePage.vue?vue&type=template&id=0272ec5e&scoped=true"
import script from "./SuperScorePage.vue?vue&type=script&lang=ts"
export * from "./SuperScorePage.vue?vue&type=script&lang=ts"
import style0 from "./SuperScorePage.vue?vue&type=style&index=0&id=0272ec5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0272ec5e",
  null
  
)

export default component.exports